{
  "close": "Zamknij"
}
